import Axios from "axios";
import React, { useState, useContext, useRef } from "react";
import ContactInformationCheck from "../components/ContactInformationCheck";
import Vehicle from "../components/Vehicle";
import swal from "sweetalert2";
import AppContext from "../context";
import LeadTypesChooser from "../components/LeadTypesChooser";
import ImportantMessage from "../components/ImportantMessage";
import Checkbox from "../components/Checkbox";
import Swal from "sweetalert2";
import { Trans, useTranslation } from "react-i18next";
import { KEYS } from "../util/keys";

const preferredTimes = [
	"Call ASAP",
	"9am – 10am",
	"11am – 12pm",
	"1pm – 2pm",
	"3pm – 4pm",
	"4pm – 5pm",
	"Call me after 5 pm"
];

export default function DownloadModal({ a }) {
	const steps = 3;
	const scrollRef = useRef();
	const [step, setStep] = useState(0.5); //0.5
	const [userData, setUserData] = useState({});
	const [selectedVehicle, setSelectedVehicle] = useState(-1);
	const [injured, setInjured] = useState(false);
	const [fault, setFault] = useState(false);
	const [consultation, setConsultation] = useState(
		a.state === "FL" ? false : undefined
	);
	const carBrain = false;
	const [confirm, setConfirm] = useState(a.hasDUI ? true : undefined);
	const [ajax, setAjax] = useState(false);
	const [leadTypes, setLeadTypes] = useState({ notInterested: true });
	const leadTypesRef = useRef({});
	const vehiclePicker = useRef();
	const { setModal } = useContext(AppContext);
	const [preferredTime, setPreferredTime] = useState("Call ASAP");
	const [tcpaText, setTcpaText] = useState(null);
	const resultIds = useRef();
	const { t, i18n } = useTranslation();

	const close = () => {
		setModal("");
	};
	const selectVehicle = (k) => {
		setSelectedVehicle(k);

		setFault(
			a.vehicles[k].contributing_factor1 &&
				a.vehicles[k].contributing_factor1 !== "NONE"
		);

		setInjured(a.vehicles[k].participants[0]?.injury !== "NOT INJURED");
	};
	const getVehicleName = () => {
		if (
			selectedVehicle !== undefined &&
			a.vehicles &&
			a.vehicles[selectedVehicle]
		) {
			return (
				(a.vehicles[selectedVehicle].vehicle_maker
					? a.vehicles[selectedVehicle].vehicle_maker
					: "") +
				(a.vehicles[selectedVehicle].vehicle_model_year
					? " " + a.vehicles[selectedVehicle].vehicle_model_year
					: "")
			);
		}
		// return "Unknown vehicle";
	};

	const getVin = () => {
		if (
			selectedVehicle !== undefined &&
			a.vehicles &&
			a.vehicles[selectedVehicle]
		) {
			return a.vehicles[selectedVehicle].vin_code;
		}
		// return "";
	};

	const getZip = () => {
		if (
			selectedVehicle !== undefined &&
			a.vehicles &&
			a.vehicles[selectedVehicle]
		) {
			return a.vehicles[selectedVehicle].owner_zip;
		}
		// return "";
	};

	const createLead = () => {
		setAjax(true);
		const businessUserToken = localStorage.getItem(KEYS.KEY_BUSINESS_USER_TOKEN) ?? undefined

		if (
			!Object.keys(leadTypesRef.current).length ||
			leadTypesRef.current.notInterested
		)
			leadTypesRef.current = { CALawyer: "AM" };

		const headers = {
			'page-referrers': window.location.href
		}

		// setTimeout(() => {
		Axios.post("/leads/create", {
			firstName: userData.name.split(" ")[0],
			lastName: userData.name.split(" ")[1],
			phone: userData.phone,
			email: userData.email,
			accidentId: a.custom_id,
			legal_consult: consultation,
			injured: injured,
			occupant: getVehicleName(),
			vin: getVin(),
			zip: getZip(),
			state: a.state,
			carBrain: carBrain,
			// lead_type: fault && a.hasDUI ? "DUILawyer" : "CALawyer",
			leadTypes: leadTypesRef.current,
			language: i18n.language,
			trusted_form_cert: window.cert?.xxTrustedFormCertUrl || "",
			gclidcrm: window.gclidcrm || "",
			businessUserToken,
		}, { headers })
			.then((d) => {
				setAjax(false);
				if (d.data.resultIds) resultIds.current = d.data.resultIds;

				if (d.data.success) {
					setStep(3);

					gtag("event", "download-pdf-success", {
						event_category: "download",
						event_label: consultation
							? "download-success-hot"
							: "download-success-cold"
					});

					if (
						consultation ||
						leadTypesRef.current.hasOwnProperty("__CALawyer")
					) {
						gtag("event", "CALawyer HOT", {
							event_category: "download",
							event_label: "CALawyer HOT"
						});
					}
				} else {
					swal.fire(
						"Error",
						"Some error ocurred while creating your request.",
						"error"
					);
				}
			})
			.catch(() => {
				setAjax(false);
				swal.fire(
					"Error",
					"Some error ocurred while creating your request.",
					"error"
				);
			});
		// }, 1000);
	};

	const updatePreferredTime = async () => {
		// console.log(resultIds.current, preferredTime);
		try {
			await Axios.put("leads/update/time", {
				ids: resultIds.current,
				preferredCallTime: preferredTime
			});
			Swal.fire(
				t("THANK_YOU"),
				t("YOUR_PREFERRED_TIME_FOR_CALL_HAS_BEEN_UPDATED"),
				"success"
			).then(() => {
				close();
			});
		} catch (e) {
			console.log(e);
		}
	};

	return (
		<div className="steps-container">
			<div className="steps">
				<div className={step >= 0.5 ? "step active" : "step"}>
					<strong>{t("STEP_1")}</strong>
					{t("CONTACT_INFORMATION")}
				</div>
				<div className={step > 1 ? "step active" : "step"}>
					<strong>{t("STEP_2")}</strong>
					{t("CONFIRMATION")}
				</div>
				<div className={step >= 3 ? "step active" : "step"}>
					<strong>{t("STEP_3")}</strong>
					{t("DOWNLOAD")}
				</div>
			</div>
			<div className="steps-progress">
				<div className="bar" style={{ width: (step / steps) * 100 + "%" }} />
			</div>
			{/* {step} */}
			<div
				className={step >= 0.5 ? "steps-page show" : "steps-page"}
				data-testid="step0"
			>
				<ContactInformationCheck
					back={close}
					next={(data) => {
						setUserData(data);
						setStep(1.5);
					}}
					smsSent={() => setStep(1)}
					state={a.state}
					zip={getZip()}
					setTcpaText={setTcpaText}
					trustedformPingUrl={window.xxTrustedFormPingUrl}
					date={a.date}
				/>
				<p style={{ textAlign: "center", marginTop: 60 }}>
					<img src="/assets/ssl.svg" width="150" />
				</p>
			</div>
			<div
				className={step >= 1.5 ? "steps-page show" : "steps-page"}
				data-testid="step1"
			>
				<h1>{t("SELECT_THE_VEHICLE_YOU_WERE_DRIVING_OR_A_PASSENGER_OF_")}</h1>
				<div className="vehicle-picker" ref={vehiclePicker}>
					{a.vehicles.map((v, k) => (
						<div
							key={v._id}
							className={selectedVehicle === k ? "selected" : ""}
							onClick={() => selectVehicle(k)}
						>
							<strong>
								{v.vehicle_maker} {v.vehicle_model_year}
							</strong>
							<Vehicle v={v} alt />
						</div>
					))}
				</div>
				<div className="vehicle-picker-arrows">
					<a
						className="left"
						onClick={() =>
							vehiclePicker.current.scrollBy({
								left: -window.innerWidth,
								behavior: "smooth"
							})
						}
					>
						<img src="/assets/icon-arrow.svg" />
					</a>
					<a
						className="right"
						onClick={() =>
							vehiclePicker.current.scrollBy({
								left: window.innerWidth,
								behavior: "smooth"
							})
						}
					>
						<img src="/assets/icon-arrow.svg" />
					</a>
				</div>
				<div className="buttons">
					<button onClick={() => close()} className="white">
						{t("BACK")}
					</button>
					<button
						onClick={() => {
							// if (fault) setStep(2);
							setStep(1.7);
						}}
						className="blue"
						disabled={selectedVehicle === -1}
					>
						{t("NEXT")}
					</button>
				</div>
				<p style={{ textAlign: "center", marginTop: 60 }}>
					<img src="/assets/ssl.svg" width="150" />
				</p>
			</div>

			<div
				className={
					step >= 1.7
						? ajax
							? "steps-page show ajax"
							: "steps-page show"
						: "steps-page"
				}
				data-testid="step2"
				ref={scrollRef}
			>
				<ImportantMessage
					legalConsult={consultation}
					setLegalConsult={(val) => {
						setConsultation(val);
						setTimeout(() => {
							/* istanbul ignore next */
							if (scrollRef.current)
								scrollRef.current.scrollTo({ top: 800, behavior: "smooth" });
						}, 100);
					}}
					setConfirm={() => {}}
					next={() => setStep(2)}
					tcpaText={tcpaText}
					isSecondaryTcpa
				/>

				<div className="buttons confirm">
					<button
						disabled={consultation === undefined}
						className="green"
						onClick={() => {
							consultation ? createLead() : setStep(2);
						}}
					>
						{consultation ? t("SUBMIT") : t("NEXT")}
					</button>
					<button className="outline" onClick={() => setStep(1.5)}>
						{t("BACK")}
					</button>
				</div>

				<p style={{ textAlign: "center", marginTop: 60 }}>
					<img src="/assets/ssl.svg" width="150" />
				</p>
			</div>

			<div
				className={step >= 2 ? "steps-page show" : "steps-page"}
				data-testid="step3"
			>
				<LeadTypesChooser
					leadTypes={leadTypes}
					onChange={(l) => {
						leadTypesRef.current = l;
						setLeadTypes(l);
					}}
				/>
				<div className="buttons" style={{ maxWidth: 700, margin: "50px auto" }}>
					<button onClick={() => setStep(1.5)} className="white">
						{t("BACK")}
					</button>
					<button
						onClick={() => createLead()}
						className="blue"
					>
						{t("ACCEPT")}
					</button>
				</div>
			</div>

			<div
				className={step >= 3 ? "steps-page show" : "steps-page"}
				data-testid="step4"
			>
				<h2 style={{ color: "var(--orange)", textAlign: "center" }}>
					{t("SUCCESS__WE_HAVE_SENT_A_DOWNLOAD_LINK_TO_YOUR_EMAIL_")}
					<br />
					<img src="/assets/email.png" width="70" style={{ marginTop: 10 }} />
				</h2>
				<p style={{ textAlign: "center" }}>
					<Trans
						i18nKey={"CHECK_YOUR_EMAIL"}
						values={{ email: userData.email }}
					/>
					<br />
				</p>

				{consultation ? (
					<div>
						<div style={{ height: 1, background: "#CCC" }} />
						<br />
						<p style={{ textAlign: "center", color: "var(--orange)" }}>
							<Trans
								i18nKey={
									"YOU_REQUESTED_TO_SPEAK_TO_SOMEONE_ABOUT_YOUR_ACCIDENT"
								}
							/>
						</p>
						<br />
						{preferredTimes.map((v) => (
							<div
								style={{
									maxWidth: i18n.language === "en" ? "170px" : "270px",
									margin: "10px auto",
									cursor: "pointer",
									display: "flex"
								}}
								onClick={() => setPreferredTime(v)}
								key={v}
							>
								<span style={{ marginRight: 8 }}>
									<Checkbox checked={preferredTime === v} />
								</span>
								{t(v)}
							</div>
						))}
						<br />
						<p style={{ textAlign: "center", fontSize: 12 }}>
							{t("MYACCIDENT_ORG_OPERATES_BETWEEN_9_AM_AND_5_PM")}
						</p>
						<br />
						<div style={{ height: 1, background: "#CCC" }}></div>
						<br />
						<div style={{ textAlign: "center" }}>
							<button
								style={{ margin: "auto", minWidth: 250 }}
								className="green"
								disabled={!preferredTime}
								onClick={() => updatePreferredTime()}
							>
								{t("SUBMIT")}
							</button>
						</div>
					</div>
				) : (
					<>
						{a.hasDUI ? (
							<div style={{ maxWidth: 500, margin: "auto", marginBottom: 30 }}>
								<div style={{ height: 1, background: "#CCC" }} />
								<br />
								<h1>{t("WHEN_SHOULD_I_HIRE_A_DUI_LAWYER")}</h1>
								<br />
								<p style={{ textAlign: "center" }}>
									<br />
									<br />
									{t("LEARN_MORE_ABOUT_IF_YOU_NEED_TO_GET_LEGAL_ADVICE")}
									<br />
									<br />
									<a
										href="https://myaccident.org/request-a-free-dui-consultation"
										className="button blue"
									>
										{t("LEARN_MORE")}
									</a>
								</p>
							</div>
						) : (
							<div style={{ maxWidth: 600, margin: "auto", marginBottom: 30 }}>
								<div style={{ height: 1, background: "#CCC" }}></div>
								<br />
								<h1>{t("WHEN_DO_I_NEED_A_LAWYER_")}</h1>
								<br />
								<p>
									<Trans
										i18nKey={"LEARN_MORE_ABOUT_IF_YOU_NEED_TO_GET_LEGAL_ADVICE"}
									/>
								</p>
								<br />
								<div style={{ textAlign: "center" }}>
									<a
										className="button blue"
										href="https://myaccident.org/request-free-legal-consultation"
										target="_blank"
									>
										{t("LEARN_MORE")}
									</a>
									<br />
									<a className="button outline" onClick={() => close()}>
										{t("CLOSE")}
									</a>
								</div>
							</div>
						)}
					</>
				)}
			</div>
		</div>
	);
}
